"use client";

import React from "react";

import { SVGIcon } from "../SVGIcon";
import { createSVGIcon } from "../util";

const VIEWBOX = "0 0 24 24";

/**
 * @deprecated use Heart from foundation/Heart with the 'fill' property
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const HeartSolid = createSVGIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M15.872 6a4.37 4.37 0 0 0-3.055 1.226l-.726.698-.712-.691a4.38 4.38 0 0 0-3.054-1.231c-1.105 0-2.21.41-3.056 1.23a4.163 4.163 0 0 0 0 5.986c2.126 2.062 4.251 4.118 6.377 6.179a.653.653 0 0 0 .91 0l6.37-6.185a4.166 4.166 0 0 0 0-5.986A4.37 4.37 0 0 0 15.873 6"
    fill="currentColor"
    stroke="currentColor"
  />,
  "Heart",
  {
    viewBox: VIEWBOX,
  }
);

/**
 * @deprecated use Heart from foundation/Heart
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Heart = createSVGIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M15.872 6a4.37 4.37 0 0 0-3.055 1.226l-.726.698-.712-.691a4.38 4.38 0 0 0-3.054-1.231c-1.105 0-2.21.41-3.056 1.23a4.163 4.163 0 0 0 0 5.986c2.126 2.062 4.251 4.118 6.377 6.179a.653.653 0 0 0 .91 0l6.37-6.185a4.166 4.166 0 0 0 0-5.986A4.37 4.37 0 0 0 15.873 6"
    fill="transparent"
    stroke="currentColor"
  />,
  "Heart",
  {
    viewBox: VIEWBOX,
  }
);

/**
 * Dynamic version of the variants of the heart icons.
 * @trackcomponent
 * @deprecated use Heart from foundation/Heart
 */
export const HeartDynamic = React.memo(
  ({
    solid = false,
    viewBox = VIEWBOX,
    ref,
    ...props
  }: SVGIcon.IProps & {
    solid?: boolean;
  } & React.RefAttributes<SVGElement>) => (
    <SVGIcon viewBox={viewBox} ref={ref} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8722 6C14.7664 6 13.6634 6.40576 12.8168 7.22628L12.0907 7.92445L11.3791 7.23258C10.5325 6.41206 9.42854 6.0018 8.32461 6.0018C7.21978 6.0018 6.11586 6.41206 5.26925 7.23258C3.57692 8.87363 3.57692 11.5781 5.26925 13.2183C7.39522 15.2795 9.5203 17.3362 11.6463 19.3965C11.7731 19.5188 11.9369 19.58 12.1015 19.58C12.2653 19.58 12.4299 19.5188 12.5568 19.3965L18.9266 13.212C20.6162 11.57 20.618 8.86733 18.9266 7.22628C18.08 6.40576 16.977 6 15.8722 6"
        fill={solid ? "currentColor" : "transparent"}
        stroke="currentColor"
      />
    </SVGIcon>
  )
);
if (process.env.NODE_ENV !== "production") {
  HeartDynamic.displayName = `HeartIcon`;
}
